const CRM = () => {
  return <>CRM Page</>;
};

export default CRM;
